import ScalarSidebarSearchInput_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarSearchInput.vue.script.js";
//#region src/components/ScalarSidebar/ScalarSidebarSearchInput.vue
var ScalarSidebarSearchInput_default = ScalarSidebarSearchInput_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarSearchInput_default as default };

//# sourceMappingURL=ScalarSidebarSearchInput.vue.js.map